import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/efashion-blanc.png'


const _hoisted_1 = {
  tabindex: "-1",
  id: "sidebarMenu",
  "aria-labelledby": "sidebarMenuLabel"
}
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = {
  key: 0,
  class: "sidebar-admin-badge"
}
const _hoisted_4 = { class: "sidebar-content" }
const _hoisted_5 = { class: "sidebar-nav" }
const _hoisted_6 = ["aria-expanded"]
const _hoisted_7 = ["aria-expanded"]
const _hoisted_8 = { class: "sidebar-menu-group" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "sidebar-menu-group" }
const _hoisted_11 = { class: "sidebar-menu-group" }
const _hoisted_12 = ["aria-expanded"]
const _hoisted_13 = ["aria-expanded"]
const _hoisted_14 = { class: "sidebar-collapsed-icons" }
const _hoisted_15 = ["title"]

import { ref, computed, watch, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useAuthStore } from "@/stores/auth";

interface Props {
  isSidebarOpen: boolean;
  isSidebarCollapsed: boolean;
  vendeurData: any;
}

interface Emits {
  (e: "toggle-sidebar"): void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  props: {
    isSidebarOpen: { type: Boolean },
    isSidebarCollapsed: { type: Boolean },
    vendeurData: {}
  },
  emits: ["toggle-sidebar"],
  setup(__props: any, { emit: __emit }) {

const authStore = useAuthStore();

const props = __props;
const emit = __emit;

const router = useRouter();
const route = useRoute();

// Vérification du MEL pour afficher/cacher "Gestion des upload photos"
const canAccessUploadPhotos = computed(() => {
  // Priorité 1: mel depuis user du store
  let mel: string | number | null = null;
  if (authStore.user?.mel !== undefined) {
    mel = authStore.user.mel;
  } else {
    // Fallback: mel depuis localStorage
    const melFromStorage = authStore.getMelFromStorage();
    if (melFromStorage) {
      mel = melFromStorage;
    }
  }

  // Autoriser uniquement MEL = 1 (UPGR - Upload photos)
  // Bloquer MEL = 0 (eFashion) et MEL = 2 (TGR - Traitement grossiste)
  return mel === "1" || mel === 1;
});

const isCollapseOpen = ref({
  account: false,
  catalogue: false,
  order: false,
  modules: false,
});

const toggleSidebar = () => {
  emit("toggle-sidebar");
};

const closeSidebar = () => {
  emit("toggle-sidebar");
};

const toggleCollapse = (section: keyof typeof isCollapseOpen.value) => {
  if (isCollapseOpen.value[section]) {
    isCollapseOpen.value[section] = false;
  } else {
    Object.keys(isCollapseOpen.value).forEach((key) => {
      isCollapseOpen.value[key as keyof typeof isCollapseOpen.value] = false;
    });
    isCollapseOpen.value[section] = true;
  }
};

const navigateTo = (routeName: string) => {
  router.push({ name: routeName });
};

// Auto-expansion de la section correspondant à la route courante
const autoExpandSection = () => {
  const path = route.path;
  const name = route.name?.toString() || '';
  if (path.includes('/catalog') || name.startsWith('catalog/')) {
    isCollapseOpen.value.catalogue = true;
  } else if (path.includes('/account') || name.startsWith('account/')) {
    isCollapseOpen.value.account = true;
  } else if (path.includes('/order') || name.startsWith('myorders') || name === 'facture') {
    isCollapseOpen.value.order = true;
  } else if (path.includes('/modules') || name.startsWith('modules/')) {
    isCollapseOpen.value.modules = true;
  }
};

onMounted(() => {
  autoExpandSection();
});

watch(() => route.fullPath, () => {
  autoExpandSection();
});

// Auto-fermeture de la sidebar sur mobile après chaque navigation
const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

watch(
  () => router.currentRoute.value.fullPath,
  () => {
    if (isMobile() && props.isSidebarOpen) {
      emit("toggle-sidebar");
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(["sidebar", { 'is-open': _ctx.isSidebarOpen, 'is-collapsed': _ctx.isSidebarCollapsed }])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "sidebar-logo"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Logo Efashion"
            }, null, -1)
          ])),
          _: 1,
          __: [8]
        }),
        _createElementVNode("button", {
          onClick: toggleSidebar,
          class: "sidebar-close-btn",
          "aria-label": "Fermer le menu"
        }, _cache[9] || (_cache[9] = [
          _createElementVNode("span", null, "×", -1)
        ]))
      ]),
      (
          _unref(authStore).isImpersonating &&
          _unref(authStore).impersonationDisplayName &&
          !_ctx.isSidebarCollapsed
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, " ADMIN : " + _toDisplayString(_unref(authStore).impersonationDisplayName), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                "aria-current": "page",
                to: "/dashboard",
                onClick: closeSidebar
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "fas fa-chart-pie" }, null, -1),
                  _createTextVNode(" Tableau de bord ")
                ])),
                _: 1,
                __: [10]
              })
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                class: "sidebar-collapse-trigger",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleCollapse('account'))),
                "aria-expanded": isCollapseOpen.value.account,
                "aria-controls": "collapseAccountMenu"
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fas fa-user-circle" }),
                  _createTextVNode("Mon compte")
                ], -1),
                _createElementVNode("i", { class: "chevron fas fa-chevron-right" }, null, -1)
              ]), 8, _hoisted_6),
              _createElementVNode("div", {
                class: _normalizeClass(["sidebar-collapse-content", isCollapseOpen.value.account ? 'is-open' : 'is-closed']),
                id: "collapseAccountMenu"
              }, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'account/infos' } }, {
                      default: _withCtx(() => _cache[12] || (_cache[12] = [
                        _createTextVNode("Informations générales")
                      ])),
                      _: 1,
                      __: [12]
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'account/brands' } }, {
                      default: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createTextVNode("Mes marques")
                      ])),
                      _: 1,
                      __: [13]
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'account/beuinfo' } }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode("Informations BEU")
                      ])),
                      _: 1,
                      __: [14]
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'account/sales' } }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("Sectoriser mes ventes")
                      ])),
                      _: 1,
                      __: [15]
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'account/discount' } }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("Mes remises et promotion")
                      ])),
                      _: 1,
                      __: [16]
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'account/promocode' } }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("Gestions des codes promos")
                      ])),
                      _: 1,
                      __: [17]
                    })
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                class: "sidebar-collapse-trigger",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleCollapse('catalogue'))),
                "aria-expanded": isCollapseOpen.value.catalogue,
                "aria-controls": "collapseCatalogueMenu"
              }, _cache[18] || (_cache[18] = [
                _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fas fa-box" }),
                  _createTextVNode("Catalogue")
                ], -1),
                _createElementVNode("i", { class: "chevron fas fa-chevron-right" }, null, -1)
              ]), 8, _hoisted_7),
              _createElementVNode("div", {
                class: _normalizeClass(["sidebar-collapse-content sidebar-collapse-content--grouped", isCollapseOpen.value.catalogue ? 'is-open' : 'is-closed']),
                id: "collapseCatalogueMenu"
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[22] || (_cache[22] = _createElementVNode("p", { class: "sidebar-menu-group-title" }, "Produits", -1)),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'catalog/mel' } }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode("Créer un produit")
                        ])),
                        _: 1,
                        __: [19]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'catalog/productlist' } }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode("Liste des produits")
                        ])),
                        _: 1,
                        __: [20]
                      })
                    ]),
                    (canAccessUploadPhotos.value)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                          _createVNode(_component_router_link, { to: { name: 'catalog/uploadphoto' } }, {
                            default: _withCtx(() => _cache[21] || (_cache[21] = [
                              _createTextVNode("Gestion des upload photos")
                            ])),
                            _: 1,
                            __: [21]
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _cache[25] || (_cache[25] = _createElementVNode("p", { class: "sidebar-menu-group-title" }, "Shooting", -1)),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'catalog/shooting-request' } }, {
                        default: _withCtx(() => _cache[23] || (_cache[23] = [
                          _createTextVNode("Faire une demande")
                        ])),
                        _: 1,
                        __: [23]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'catalog/listmel' } }, {
                        default: _withCtx(() => _cache[24] || (_cache[24] = [
                          _createTextVNode("Liste des mises en ligne")
                        ])),
                        _: 1,
                        __: [24]
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _cache[28] || (_cache[28] = _createElementVNode("p", { class: "sidebar-menu-group-title" }, "Tailles", -1)),
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'catalog/sizerange' } }, {
                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                          _createTextVNode("Gestion des gammes de tailles")
                        ])),
                        _: 1,
                        __: [26]
                      })
                    ]),
                    _createElementVNode("li", null, [
                      _createVNode(_component_router_link, { to: { name: 'catalog/packagemanagement' } }, {
                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                          _createTextVNode("Gestion des paquets")
                        ])),
                        _: 1,
                        __: [27]
                      })
                    ])
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                class: "sidebar-collapse-trigger",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleCollapse('order'))),
                "aria-expanded": isCollapseOpen.value.order,
                "aria-controls": "collapseOrderMenu"
              }, _cache[29] || (_cache[29] = [
                _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fas fa-clipboard-list" }),
                  _createTextVNode("Commandes")
                ], -1),
                _createElementVNode("i", { class: "chevron fas fa-chevron-right" }, null, -1)
              ]), 8, _hoisted_12),
              _createElementVNode("div", {
                class: _normalizeClass(["sidebar-collapse-content", isCollapseOpen.value.order ? 'is-open' : 'is-closed']),
                id: "collapseOrderMenu"
              }, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'myorders' },
                      "active-class": "",
                      "exact-active-class": "router-link-exact-active"
                    }, {
                      default: _withCtx(() => _cache[30] || (_cache[30] = [
                        _createTextVNode("Mes commandes")
                      ])),
                      _: 1,
                      __: [30]
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'facture' },
                      "active-class": "",
                      "exact-active-class": "router-link-exact-active"
                    }, {
                      default: _withCtx(() => _cache[31] || (_cache[31] = [
                        _createTextVNode("Mes factures")
                      ])),
                      _: 1,
                      __: [31]
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'my-litiges-retours' },
                      "active-class": "",
                      "exact-active-class": "router-link-exact-active"
                    }, {
                      default: _withCtx(() => _cache[32] || (_cache[32] = [
                        _createTextVNode("Mes litiges et retours")
                      ])),
                      _: 1,
                      __: [32]
                    })
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                class: "sidebar-collapse-trigger",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (toggleCollapse('modules'))),
                "aria-expanded": isCollapseOpen.value.modules,
                "aria-controls": "collapseModulesMenu"
              }, _cache[33] || (_cache[33] = [
                _createElementVNode("span", null, [
                  _createElementVNode("i", { class: "fas fa-puzzle-piece" }),
                  _createTextVNode("Modules")
                ], -1),
                _createElementVNode("i", { class: "chevron fas fa-chevron-right" }, null, -1)
              ]), 8, _hoisted_13),
              _createElementVNode("div", {
                class: _normalizeClass(["sidebar-collapse-content", isCollapseOpen.value.modules ? 'is-open' : 'is-closed']),
                id: "collapseModulesMenu"
              }, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'modules/lookbook' } }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createTextVNode("Gestion des lookbooks")
                      ])),
                      _: 1,
                      __: [34]
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, { to: { name: 'modules/buyers' } }, {
                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                        _createTextVNode("Gestion des acheteurs")
                      ])),
                      _: 1,
                      __: [35]
                    })
                  ])
                ])
              ], 2)
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: { name: 'prestationproducts' },
                onClick: closeSidebar
              }, {
                default: _withCtx(() => _cache[36] || (_cache[36] = [
                  _createElementVNode("i", { class: "fas fa-store" }, null, -1),
                  _createTextVNode(" Store Efashion ")
                ])),
                _: 1,
                __: [36]
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                to: { name: 'services' },
                onClick: closeSidebar
              }, {
                default: _withCtx(() => _cache[37] || (_cache[37] = [
                  _createElementVNode("i", { class: "fas fa-gem" }, null, -1),
                  _createTextVNode(" Services ")
                ])),
                _: 1,
                __: [37]
              })
            ])
          ])
        ])
      ], 512), [
        [_vShow, !_ctx.isSidebarCollapsed]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_14, [
        (_unref(authStore).isImpersonating && _unref(authStore).impersonationDisplayName)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sidebar-admin-badge collapsed",
              title: 'ADMIN : ' + _unref(authStore).impersonationDisplayName
            }, " ADMIN ", 8, _hoisted_15))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: "collapsed-icon",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/'))),
          title: "Tableau de bord"
        }, _cache[38] || (_cache[38] = [
          _createElementVNode("i", { class: "fas fa-home" }, null, -1)
        ])),
        _createElementVNode("div", {
          class: "collapsed-icon",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (navigateTo('account/infos'))),
          title: "Informations générales"
        }, _cache[39] || (_cache[39] = [
          _createElementVNode("i", { class: "fas fa-user-circle" }, null, -1)
        ])),
        _createElementVNode("div", {
          class: "collapsed-icon",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (navigateTo('catalog/productlist'))),
          title: "Liste des produits"
        }, _cache[40] || (_cache[40] = [
          _createElementVNode("i", { class: "fas fa-boxes" }, null, -1)
        ])),
        _createElementVNode("div", {
          class: "collapsed-icon",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (navigateTo('myorders'))),
          title: "Mes commandes"
        }, _cache[41] || (_cache[41] = [
          _createElementVNode("i", { class: "fas fa-clipboard-list" }, null, -1)
        ]))
      ], 512), [
        [_vShow, _ctx.isSidebarCollapsed]
      ])
    ])
  ], 2))
}
}

})